/* eslint-disable import/prefer-default-export */
import type { BackOfficeConfig } from '../types/backOffice.js';

export const defaultConfig: BackOfficeConfig = {
  appName: 'PyxiScience',
  authentication: {
    type: 'none', // L'authentification sera gérée par l'AuthProvider via l'API
  },
  views: [
    {
      label: 'Administrateurs',
      type: 'table',
      tableName: 'Administrator',
      idColumnName: 'administratorId',
      icon: 'user-tie',
      orderBy: 'createdAt',
      columns: [
        {
          label: 'Nom',
          name: 'lastName',
          searchable: true,
        },
        {
          label: 'Prénom',
          name: 'firstName',
          searchable: true,
        },
        {
          label: 'Email',
          name: 'email',
          required: true,
          searchable: true,
        },
        {
          label: 'Date de création',
          name: 'createdAt',
          type: 'datetime',
          hideInEdit: true,
        },
        {
          label: 'Date de désactivation',
          name: 'deactivatedAt',
          type: 'datetime',
          hideInTable: true,
        },
        {
          label: 'ID',
          name: 'administratorId',
          hideInTable: true,
          searchable: true,
        },
      ],
    },
    {
      label: 'Élèves',
      type: 'table',
      tableName: 'Student',
      idColumnName: 'studentId',
      icon: 'user',
      orderBy: 'Student.createdAt',
      columns: [
        {
          label: 'Nom',
          name: 'lastName',
          searchable: true,
        },
        {
          label: 'Prénom',
          name: 'firstName',
          searchable: true,
        },
        {
          label: 'Email',
          name: 'email',
          type: 'email',
          required: true,
          searchable: true,
        },
        {
          label: 'Établissement fréquenté',
          name: 'establishment',
          searchable: true,
        },
        {
          label: 'Date de création',
          name: 'createdAt',
          type: 'datetime',
          hideInEdit: true,
        },
        {
          label: 'Crédits abonnement (correction de copies)',
          name: 'correctionCredits',
          type: 'number',
          hideInTable: true,
        },
        {
          label: 'Crédits achetés (correction de copies)',
          name: 'purchasedCorrectionCredits',
          type: 'number',
          hideInTable: true,
        },
        {
          label: 'Date de désactivation',
          name: 'deactivatedAt',
          type: 'datetime',
          hideInTable: true,
        },
        {
          label: 'ID',
          name: 'studentId',
          hideInTable: true,
          searchable: true,
        },
      ],
      sidePanels: [
        {
          label: 'Classes',
          type: 'table',
          route: 'student-classes-student',
          tableName: 'StudentClassStudent',
          idColumnName: 'studentClassStudentId',
          joins: [
            {
              tableName: 'StudentClass',
              on: 'studentClassId',
            },
          ],
          columns: [
            {
              label: 'Classe',
              type: 'foreign',
              name: 'StudentClass.name',
              tableName: 'StudentClass',
              idColumnName: 'studentClassId',
              foreignIdColumnName: 'studentClassId',
              searchField: 'name',
            },
          ],
        },
        {
          label: 'Permissions',
          type: 'table',
          route: 'student-access',
          tableName: 'StudentAccess',
          idColumnName: 'studentAccessId',
          columns: [
            {
              label: 'Permission',
              name: 'permission',
              type: 'select',
              options: {
                platform: 'Plateforme',
                correction: 'Correction',
                bacAnnales: 'Bac Annales',
                bacAnnalesPremium: 'Bac Annales Premium',
              },
            },
            {
              label: 'Expiration',
              name: 'expiresAt',
              type: 'datetime',
            },
          ],
        },
      ],
    },
    {
      label: 'Professeurs',
      type: 'table',
      route: 'teacher',
      tableName: 'Teacher',
      idColumnName: 'teacherId',
      icon: 'school',
      orderBy: 'createdAt',
      columns: [
        {
          label: 'Nom',
          name: 'lastName',
          searchable: true,
        },
        {
          label: 'Prénom',
          name: 'firstName',
          searchable: true,
        },
        {
          label: 'Email',
          name: 'email',
          type: 'email',
          required: true,
          searchable: true,
        },
        {
          label: 'Établissement fréquenté',
          name: 'establishment',
          searchable: true,
        },
        {
          label: 'Date de création',
          name: 'createdAt',
          type: 'datetime',
          hideInEdit: true,
        },
        {
          label: 'Crédits abonnement (correction de copies)',
          name: 'correctionCredits',
          type: 'number',
          hideInTable: true,
        },
        {
          label: 'Crédits achetés (correction de copies)',
          name: 'purchasedCorrectionCredits',
          type: 'number',
          hideInTable: true,
        },
        {
          label: 'Date de désactivation',
          name: 'deactivatedAt',
          type: 'datetime',
          hideInTable: true,
        },
        {
          label: 'ID',
          name: 'teacherId',
          hideInTable: true,
          searchable: true,
        },
      ],
      sidePanels: [
        {
          label: 'Classes',
          type: 'table',
          route: 'teacher-student-class',
          tableName: 'StudentClassTeacher',
          idColumnName: 'studentClassTeacherId',
          joins: [
            {
              tableName: 'StudentClass',
              on: 'studentClassId',
            },
          ],
          columns: [
            {
              label: 'Classe',
              type: 'foreign',
              name: 'StudentClass.name',
              tableName: 'StudentClass',
              idColumnName: 'studentClassId',
              foreignIdColumnName: 'studentClassId',
              searchField: 'name',
            },
          ],
        },
        {
          label: 'Permissions',
          type: 'table',
          route: 'teacher-access',
          tableName: 'TeacherAccess',
          idColumnName: 'teacherAccessId',
          columns: [
            {
              label: 'Permission',
              name: 'permission',
              type: 'select',
              options: {
                platform: 'Plateforme',
                correction: 'Correction',
              },
            },
            {
              label: 'Expiration',
              name: 'expiresAt',
              type: 'datetime',
            },
          ],
        },
      ],
    },
    {
      label: 'Cursus',
      type: 'table',
      tableName: 'Curriculum',
      idColumnName: 'curriculumId',
      icon: 'graduation-cap',
      orderBy: 'createdAt',
      columns: [
        {
          label: 'Nom',
          name: 'name',
          searchable: true,
        },
        {
          label: 'Nom (Identifiant)',
          name: 'nameId',
          searchable: true,
        },
        {
          label: 'Date de création',
          name: 'createdAt',
          type: 'datetime',
          hideInEdit: true,
        },
        { label: 'ID', name: 'curriculumId', hideInTable: true, searchable: true },
      ],
      sidePanels: [
        {
          label: 'Modules',
          type: 'table',
          route: 'curriculum-module',
          tableName: 'CurriculumModule',
          idColumnName: 'curriculumModuleId',
          joins: [
            {
              tableName: 'Module',
              on: 'moduleId',
            },
          ],
          columns: [
            {
              label: 'Module',
              type: 'foreign',
              name: 'Module.name',
              tableName: 'Module',
              idColumnName: 'moduleId',
              foreignIdColumnName: 'moduleId',
              searchField: 'name',
            },
            {
              label: 'NomId',
              name: 'Module.nameId',
              hideInEdit: true,
            },
            {
              label: 'Semestre',
              name: 'category',
              type: 'select',
              options: {
                semester1: 'Semestre 1',
                semester2: 'Semestre 2',
              },
            },
          ],
        },
      ],
    },
    {
      label: 'Modules',
      type: 'table',
      tableName: 'Module',
      idColumnName: 'moduleId',
      icon: 'book',
      orderBy: 'createdAt',
      columns: [
        {
          label: 'Nom',
          name: 'name',
          searchable: true,
        },
        {
          label: 'Nom (Identifiant)',
          name: 'nameId',
          searchable: true,
        },
        // {
        //   label: 'Visites',
        //   type: 'matomo-module-view',
        //   hideInTable: true,
        // },
        {
          label: 'Date de création',
          name: 'createdAt',
          type: 'datetime',
          hideInEdit: true,
        },
        {
          label: 'ID',
          name: 'moduleId',
          hideInTable: true,
          searchable: true,
        },
      ],
      sidePanels: [
        {
          label: 'Cursus',
          type: 'table',
          route: 'module-curriculum',
          tableName: 'CurriculumModule',
          idColumnName: 'curriculumModuleId',
          joins: [
            {
              tableName: 'Module',
              on: 'moduleId',
            },
            {
              tableName: 'Curriculum',
              on: 'curriculumId',
            },
          ],
          columns: [
            {
              label: 'Cursus',
              type: 'foreign',
              name: 'Curriculum.name',
              tableName: 'Curriculum',
              idColumnName: 'curriculumId',
              foreignIdColumnName: 'curriculumId',
              searchField: 'name',
            },
            {
              label: 'Semestre',
              name: 'category',
              type: 'select',
              options: {
                semester1: 'Semestre 1',
                semester2: 'Semestre 2',
              },
            },
          ],
        },
        {
          label: 'Classes',
          type: 'table',
          route: 'module-student-class',
          tableName: 'StudentClassModule',
          idColumnName: 'studentClassModuleId',
          joins: [
            {
              tableName: 'StudentClass',
              on: 'studentClassId',
            },
          ],
          columns: [
            {
              label: 'Classe',
              type: 'foreign',
              name: 'StudentClass.name',
              tableName: 'StudentClass',
              idColumnName: 'studentClassId',
              foreignIdColumnName: 'studentClassId',
              searchField: 'name',
            },
            {
              label: 'Semestre',
              name: 'category',
              type: 'select',
              options: {
                semester1: 'Semestre 1',
                semester2: 'Semestre 2',
              },
            },
          ],
        },
        {
          label: 'Notions',
          type: 'table',
          route: 'module-notion',
          tableName: 'ModuleNotion',
          idColumnName: 'moduleNotionId',
          joins: [
            {
              tableName: 'Notion',
              on: 'notionId',
            },
          ],
          columns: [
            {
              label: 'Notion',
              type: 'foreign',
              name: 'Notion.nameFr',
              tableName: 'Notion',
              idColumnName: 'notionId',
              foreignIdColumnName: 'notionId',
              searchField: 'nameFr',
            },
          ],
        },
        {
          type: 'table',
          label: 'Chapitres',
          route: 'module-chapter',
          tableName: 'ChapterModule',
          idColumnName: 'chapterModuleId',
          orderBy: 'ChapterModule.chapterOrder',
          joins: [
            {
              tableName: 'Chapter',
              on: 'chapterId',
            },
          ],
          columns: [
            {
              label: 'Chapitre',
              type: 'foreign',
              name: 'Chapter.name',
              tableName: 'Chapter',
              idColumnName: 'chapterId',
              foreignIdColumnName: 'chapterId',
              searchField: 'name',
            },
            {
              label: 'NomId',
              name: 'Chapter.nameId',
              hideInEdit: true,
            },
            {
              label: 'Ordre',
              type: 'number',
              name: 'chapterOrder',
            },
          ],
        },
        {
          label: 'Exercices',
          type: 'table',
          route: 'module-exercise',
          tableName: 'ModuleExercise',
          idColumnName: 'moduleExerciseId',
          joins: [
            {
              tableName: 'Exercise',
              on: 'exerciseId',
            },
          ],
          columns: [
            {
              label: 'Exercice',
              type: 'foreign',
              name: 'Exercise.name',
              tableName: 'Exercise',
              idColumnName: 'exerciseId',
              foreignIdColumnName: 'exerciseId',
              searchField: 'name',
            },
          ],
        },
      ],
    },
    {
      label: 'Classes',
      type: 'table',
      tableName: 'StudentClass',
      idColumnName: 'studentClassId',
      icon: 'users',
      orderBy: 'StudentClass.createdAt',
      joins: [
        {
          tableName: 'Curriculum',
          on: 'curriculumId',
        },
        {
          tableName: 'StudentClass',
          as: 'ParentStudentClass',
          on: {
            leftId: 'ParentStudentClass.studentClassId',
            rightId: 'StudentClass.parentStudentClassId',
          },
        },
      ],
      columns: [
        {
          label: 'Nom',
          name: 'name',
          searchable: true,
        },
        {
          label: 'Cursus',
          type: 'foreign',
          name: 'Curriculum.name',
          tableName: 'Curriculum',
          idColumnName: 'curriculumId',
          foreignIdColumnName: 'curriculumId',
          searchField: 'name',
        },
        {
          label: 'Classe mère',
          type: 'foreign',
          name: 'ParentStudentClass.name',
          tableName: 'StudentClass',
          idColumnName: 'parentStudentClassId',
          foreignIdColumnName: 'studentClassId',
          searchField: 'name',
        },
        {
          label: 'Date de création',
          name: 'createdAt',
          type: 'datetime',
          hideInEdit: true,
        },
        { label: 'ID', name: 'studentClassId', hideInTable: true, searchable: true },
      ],
      sidePanels: [
        {
          label: 'Modules',
          type: 'table',
          route: 'student-class-module',
          tableName: 'StudentClassModule',
          idColumnName: 'studentClassModuleId',
          joins: [
            {
              tableName: 'Module',
              on: 'moduleId',
            },
          ],
          columns: [
            {
              label: 'Module',
              type: 'foreign',
              name: 'Module.name',
              idColumnName: 'moduleId',
              foreignIdColumnName: 'moduleId',
              searchField: 'name',
              tableName: 'Module',
            },
            {
              label: 'NomId',
              name: 'Module.nameId',
              hideInEdit: true,
            },
            {
              label: 'Semestre',
              name: 'category',
              type: 'select',
              options: {
                semester1: 'Semestre 1',
                semester2: 'Semestre 2',
              },
            },
          ],
        },
        {
          label: 'Elèves',
          type: 'table',
          route: 'student-class-student',
          tableName: 'StudentClassStudent',
          idColumnName: 'studentClassStudentId',
          joins: [
            {
              tableName: 'Student',
              on: 'studentId',
            },
          ],
          columns: [
            {
              label: 'Nom',
              name: 'Student.lastName',
              hideInEdit: true,
            },
            {
              label: 'Prénom',
              name: 'Student.firstName',
              hideInEdit: true,
            },
            {
              type: 'foreign',
              label: 'Elève',
              name: 'Student.email',
              idColumnName: 'studentId',
              foreignIdColumnName: 'studentId',
              searchField: 'email',
              tableName: 'Student',
            },
            {
              label: 'Date de création',
              name: 'createdAt',
              type: 'datetime',
              hideInEdit: true,
            },
          ],
        },
        {
          type: 'table',
          label: 'Professeurs',
          tableName: 'StudentClassTeacher',
          route: 'student-class-teacher',
          idColumnName: 'studentClassTeacherId',
          joins: [
            {
              tableName: 'Teacher',
              on: 'teacherId',
            },
          ],
          columns: [
            {
              label: 'Nom',
              name: 'Teacher.lastName',
              hideInEdit: true,
            },
            {
              label: 'Prénom',
              name: 'Teacher.firstName',
              hideInEdit: true,
            },
            {
              type: 'foreign',
              label: 'Professeur',
              name: 'Teacher.email',
              idColumnName: 'teacherId',
              foreignIdColumnName: 'teacherId',
              searchField: 'email',
              tableName: 'Teacher',
            },
            {
              label: 'Date de création',
              name: 'createdAt',
              type: 'datetime',
              hideInEdit: true,
            },
          ],
        },
      ],
    },
    {
      label: 'Notions',
      type: 'table',
      tableName: 'Notion',
      idColumnName: 'notionId',
      icon: 'lightbulb',
      orderBy: 'createdAt',
      columns: [
        {
          label: 'Nom (Identifiant)',
          name: 'nameId',
          searchable: true,
        },
        {
          label: 'Nom (FR)',
          name: 'nameFr',
          searchable: true,
        },
        {
          label: 'Nom (EN)',
          name: 'nameEn',
          searchable: true,
        },
        {
          label: 'Math Field',
          name: 'mathField',
          type: 'select',
          options: {
            analysis: 'Analyse',
            algebra: 'Algèbre',
            probability: 'Probabilité',
            mathematics: 'Mathématiques',
            financial: 'Financière',
            geometry: 'Géométrie',
            setsAndLogic: 'Logique et Fondements',
            others: 'Autres',
          },
        },
        {
          label: 'Date de création',
          name: 'createdAt',
          type: 'datetime',
          hideInEdit: true,
        },
        { label: 'ID', name: 'notionId', hideInTable: true, searchable: true },
      ],
      sidePanels: [
        {
          type: 'table',
          label: 'Modules',
          tableName: 'ModuleNotion',
          route: 'notion-module',
          idColumnName: 'moduleNotionId',
          joins: [
            {
              tableName: 'Module',
              on: 'moduleId',
            },
          ],
          columns: [
            {
              type: 'foreign',
              label: 'Module',
              name: 'Module.name',
              idColumnName: 'moduleId',
              foreignIdColumnName: 'moduleId',
              searchField: 'name',
              tableName: 'Module',
            },
            {
              label: 'NomId',
              name: 'Module.nameId',
              hideInEdit: true,
            },
          ],
        },
      ],
    },
    {
      label: 'Structures',
      type: 'table',
      tableName: 'Structure',
      idColumnName: 'structureId',
      icon: 'building',
      orderBy: 'createdAt',
      columns: [
        {
          label: 'Nom (identifiant)',
          name: 'nameId',
          searchable: true,
        },
        {
          label: 'Contenu de la structure',
          name: 'content',
          type: {
            default: 'myst',
            edit: 'myst-editor',
            read: 'myst',
          },
          hideInTable: true,
        },
        {
          label: 'Date de création',
          name: 'createdAt',
          type: 'datetime',
          hideInEdit: true,
        },
        {
          label: 'ID',
          name: 'structureId',
          hideInTable: true,
          searchable: true,
        },
      ],
    },
    {
      label: 'Chapitres',
      type: 'table',
      tableName: 'Chapter',
      idColumnName: 'chapterId',
      icon: 'book',
      orderBy: 'createdAt',
      onEditApiRoute: '../../../back-office/chapter/:recordId',
      canCreate: false,
      columns: [
        {
          label: 'Titre du chapitre',
          name: 'name',
          searchable: true,
        },
        {
          label: 'Nom (identifiant)',
          name: 'nameId',
          searchable: true,
        },
        {
          label: 'Contenu du chapitre',
          name: 'content',
          type: {
            default: 'myst',
            read: 'myst',
          },
          hideInTable: true,
          hideInEdit: true,
        },
        {
          label: 'Date de création',
          name: 'createdAt',
          type: 'datetime',
          hideInEdit: true,
        },
        {
          label: 'ID',
          name: 'chapterId',
          hideInTable: true,
          searchable: true,
        },
        {
          label: 'Action',
          type: 'actionChapter',
          hideInTable: true,
        },
      ],
      sidePanels: [
        {
          label: 'Exercices',
          type: 'table',
          route: 'chapter-exercise',
          tableName: 'ChapterExercise',
          idColumnName: 'chapterExerciseId',
          joins: [
            {
              tableName: 'Exercise',
              on: 'exerciseId',
            },
          ],
          columns: [
            {
              label: 'Exercice',
              type: 'foreign',
              name: 'Exercise.name',
              tableName: 'Exercise',
              idColumnName: 'exerciseId',
              foreignIdColumnName: 'exerciseId',
              searchField: 'name',
            },
          ],
        },
        {
          label: 'Modules',
          type: 'table',
          route: 'chapter-module',
          tableName: 'ChapterModule',
          idColumnName: 'chapterModuleId',
          orderBy: 'ChapterModule.chapterOrder',
          joins: [
            {
              tableName: 'Module',
              on: 'moduleId',
            },
          ],
          columns: [
            {
              label: 'Module',
              type: 'foreign',
              name: 'Module.name',
              tableName: 'Module',
              idColumnName: 'moduleId',
              foreignIdColumnName: 'moduleId',
              searchField: 'name',
            },
            {
              label: 'NomId',
              name: 'Module.nameId',
              hideInEdit: true,
            },
            {
              label: 'Ordre',
              type: 'number',
              name: 'chapterOrder',
            },
          ],
        },
      ],
    },
    {
      label: 'Exercices',
      type: 'table',
      route: 'exercise',
      tableName: 'Exercise',
      idColumnName: 'exerciseId',
      icon: 'book',
      orderBy: 'ExerciseSubmission.processedAt',
      orderByDirection: 'DESC',
      customSubmit: 'actionUpdateExercise',
      where:
        "ExerciseSubmission.status = 'validated' OR ExerciseSubmission.exerciseSubmissionId IS NULL",
      canCreate: false,
      joins: [
        {
          tableName: 'ExerciseSubmission',
          type: 'LEFT',
          on: 'exerciseId',
        },
        {
          tableName: 'Administrator',
          type: 'LEFT',
          on: {
            leftId: 'ExerciseSubmission.submittedById',
            rightId: 'SubmittedBy.administratorId',
          },
          as: 'SubmittedBy',
        },
        {
          tableName: 'Administrator',
          type: 'LEFT',
          on: {
            leftId: 'ExerciseSubmission.processedById',
            rightId: 'ProcessedBy.administratorId',
          },
          as: 'ProcessedBy',
        },
      ],
      onEditApiRoute: '../../../back-office/exercise/:recordId',
      columns: [
        {
          label: 'Titre',
          name: 'name',
          searchable: true,
        },
        {
          label: 'Durée',
          name: 'duration',
          hideInTable: true,
        },
        {
          label: 'Difficulté',
          name: 'level',
          type: 'select',
          options: {
            elementary: 'Élémentaire',
            intermediate: 'Intermédiaire',
            advanced: 'Avancé',
          },
          hideInTable: true,
          searchable: true,
        },
        {
          label: 'Soumis par',
          name: 'SubmittedBy.firstName',
          format: {
            type: 'concatenate',
            config: {
              fields: ['SubmittedBy.lastName', 'SubmittedBy.firstName'],
              separator: ' ',
            },
          },
          hideInEdit: true,
          searchable: true,
        },
        {
          label: 'Traité par',
          name: 'ProcessedBy.firstName',
          format: {
            type: 'concatenate',
            config: {
              fields: ['ProcessedBy.lastName', 'ProcessedBy.firstName'],
              separator: ' ',
            },
          },
          hideInEdit: true,
          searchable: true,
        },
        {
          label: 'Commentaire',
          name: 'comment',
          type: 'textarea',
          hideInTable: true,
        },
        {
          label: 'Action',
          type: 'actionExercise',
          hideInTable: true,
        },
        {
          label: 'Enoncé',
          name: 'statement',
          type: {
            default: 'myst',
            edit: 'myst-editor',
            view: 'string',
          },
          hideInTable: true,
          hideInEdit: true,
        },
        {
          label: 'Public concerné',
          name: 'visibility',
          hideInTable: true,
          type: 'select',
          options: {
            teacher: 'Professeur',
            lecture: 'Cours',
            all: 'Tout le monde',
          },
        },
        {
          label: 'Date de création',
          name: 'createdAt',
          type: 'datetime',
          hideInTable: true,
          hideInEdit: true,
        },
        {
          label: 'Date de modification',
          name: 'updatedAt',
          type: 'datetime',
          hideInTable: true,
          hideInEdit: true,
        },
        {
          label: 'Date de soumission',
          name: 'ExerciseSubmission.createdAt',
          type: 'datetime',
          hideInEdit: true,
        },
        {
          label: 'Date de validation',
          name: 'ExerciseSubmission.processedAt',
          type: 'datetime',
          hideInEdit: true,
        },
        {
          label: 'ID',
          name: 'exerciseId',
          hideInTable: true,
          searchable: true,
        },
        {
          label: 'ID original',
          name: 'originalExerciseId',
          hideInTable: true,
          searchable: true,
        },
      ],
      sidePanels: [
        {
          type: 'custom-side-panel',
          route: 'questions',
          label: 'Questions',
          path: 'ExerciseQuestionSidePanel.tsx',
          customConfig: {},
        },
        {
          type: 'table',
          label: 'Modules',
          tableName: 'ModuleExercise',
          route: 'exercise-module',
          idColumnName: 'moduleExerciseId',
          joins: [
            {
              tableName: 'Module',
              on: 'moduleId',
            },
          ],
          columns: [
            {
              type: 'foreign',
              label: 'Module',
              name: 'Module.name',
              idColumnName: 'moduleId',
              foreignIdColumnName: 'moduleId',
              searchField: 'name',
              tableName: 'Module',
            },
            {
              label: 'NomId',
              name: 'Module.nameId',
              hideInEdit: true,
            },
          ],
        },
        {
          type: 'table',
          label: 'Chapitres',
          tableName: 'ChapterExercise',
          route: 'exercise-chapter',
          idColumnName: 'chapterExerciseId',
          joins: [
            {
              tableName: 'Chapter',
              on: 'chapterId',
            },
          ],
          columns: [
            {
              type: 'foreign',
              label: 'Chapitre',
              name: 'Chapter.name',
              idColumnName: 'chapterId',
              foreignIdColumnName: 'chapterId',
              searchField: 'name',
              tableName: 'Chapter',
            },
            {
              label: 'NomId',
              name: 'Chapter.nameId',
              hideInEdit: true,
            },
          ],
        },
        {
          type: 'table',
          label: 'Notions',
          tableName: 'ExerciseNotion',
          idColumnName: 'exerciseNotionId',
          route: 'exercise-notion',
          joins: [
            {
              tableName: 'Notion',
              on: 'notionId',
            },
          ],
          columns: [
            {
              type: 'foreign',
              label: 'Notion',
              name: 'Notion.nameFr',
              idColumnName: 'notionId',
              foreignIdColumnName: 'notionId',
              searchField: 'nameFr',
              tableName: 'Notion',
            },
          ],
        },
        {
          type: 'custom-side-panel',
          route: 'versions',
          label: 'Versions',
          path: 'ExerciseVersionSidePanel.tsx',
          customConfig: {
            paths: {
              read: {
                path: 'ExerciseVersionRead.tsx',
                label: 'Détail de la version',
                route: 'detail-exercise-version',
              },
            },
          },
        },
      ],
    },
    {
      label: 'Documentation',
      type: 'table',
      route: 'documentation-document',
      tableName: 'DocumentationDocument',
      idColumnName: 'documentationDocumentId',
      icon: 'file-alt',
      canCreate: false,
      orderBy: 'updatedAt',
      orderByDirection: 'DESC',
      onCreateApiRoute: 'documentation/document',
      onEditApiRoute: 'documentation/document/:recordId',
      joins: [
        {
          tableName: 'DocumentationSection',
          type: 'LEFT',
          on: {
            leftId: 'DocumentationDocument.sectionId',
            rightId: 'DocumentationSection.documentationSectionId',
          },
        },
      ],
      columns: [
        { label: 'Titre (FR)', name: 'titleFR', searchable: true },
        { label: 'Titre (EN)', name: 'titleEN', searchable: true },
        {
          label: 'Accès',
          name: 'access',
          type: 'select',
          options: { Public: 'Public', Teacher: 'Professeur', Student: 'Élève' },
          searchable: true,
        },
        {
          label: 'Statut',
          name: 'isPublished',
          type: 'select',
          // isPublished is stored as 0/1; keys must match the stored value to resolve the label.
          options: { 0: 'Brouillon', 1: 'Publié' },
        },
        {
          // Position is specific to a (section, access) scope; it only becomes meaningful — and
          // sortable/movable — once both filters are set on the Documents view.
          label: 'Position',
          name: 'position',
          type: 'number',
        },
        {
          // Display the section's FR title (via the join); on edit, write back `sectionId`
          // (foreign columns submit under `idColumnName`).
          label: 'Section',
          name: 'DocumentationSection.titleFR',
          type: 'foreign',
          tableName: 'DocumentationSection',
          idColumnName: 'sectionId',
          foreignIdColumnName: 'documentationSectionId',
          searchField: 'titleFR',
        },
        {
          label: 'Action',
          type: 'actionDocumentation',
          hideInTable: true,
        },
        {
          label: 'Contenu',
          name: 'body',
          type: { default: 'myst', edit: 'myst-editor', view: 'string' },
          hideInTable: true,
        },
        {
          label: 'Date de modification',
          name: 'updatedAt',
          type: 'datetime',
          hideInEdit: true,
        },
        { label: 'ID', name: 'documentationDocumentId', hideInTable: true, searchable: true },
      ],
    },
    {
      label: 'Validation Profs',
      type: 'table',
      route: 'validation-exercice-profs',
      icon: 'check-circle',
      tableName: 'Exercise',
      idColumnName: 'exerciseId',
      orderBy: 'Exercise.createdAt',
      orderByDirection: 'DESC',
      where: 'Exercise.idExerciseTeacher IS NOT NULL AND Exercise.isPublic = false',
      canCreate: false,
      joins: [
        {
          tableName: 'Exercise',
          type: 'INNER',
          on: {
            leftId: 'Exercise.idExerciseTeacher',
            rightId: 'MainExercise.exerciseId',
          },
          as: 'MainExercise',
        },
        {
          tableName: 'Teacher',
          type: 'LEFT',
          on: {
            leftId: 'MainExercise.teacherId',
            rightId: 'Teacher.teacherId',
          },
          as: 'Teacher',
        },
      ],
      columns: [
        {
          label: 'Titre',
          name: 'name',
          searchable: true,
        },
        {
          label: 'Durée',
          name: 'duration',
          hideInTable: true,
        },
        {
          label: 'Difficulté',
          name: 'level',
          type: 'select',
          options: {
            elementary: 'Élémentaire',
            intermediate: 'Intermédiaire',
            advanced: 'Avancé',
          },
          hideInTable: true,
        },
        {
          label: 'Enseignant',
          name: 'Teacher.firstName',
          format: {
            type: 'concatenate',
            config: {
              fields: ['Teacher.lastName', 'Teacher.firstName'],
              separator: ' ',
            },
          },
        },
        {
          label: 'Commentaire',
          name: 'comment',
          type: 'textarea',
          hideInTable: true,
        },
        {
          label: 'Enoncé',
          name: 'statement',
          type: {
            default: 'myst',
            edit: 'myst-editor',
            view: 'string',
          },
          hideInTable: true,
          hideInEdit: true,
        },
        {
          label: 'Action',
          type: 'actionValidateTeacher',
          hideInTable: true,
        },
        {
          label: 'Date de création',
          name: 'createdAt',
          type: 'datetime',
          hideInEdit: true,
        },
        {
          label: 'ID',
          name: 'exerciseId',
          hideInTable: true,
          searchable: true,
        },
      ],
      sidePanels: [
        {
          type: 'table',
          label: 'Modules',
          tableName: 'ModuleExercise',
          route: 'exercise-module',
          idColumnName: 'moduleExerciseId',
          joins: [
            {
              tableName: 'Module',
              on: 'moduleId',
            },
          ],
          columns: [
            {
              type: 'foreign',
              label: 'Module',
              name: 'Module.name',
              idColumnName: 'moduleId',
              foreignIdColumnName: 'moduleId',
              searchField: 'name',
              tableName: 'Module',
            },
            {
              label: 'NomId',
              name: 'Module.nameId',
              hideInEdit: true,
            },
          ],
        },
        {
          type: 'table',
          label: 'Chapitres',
          tableName: 'ChapterExercise',
          route: 'exercise-chapter',
          idColumnName: 'chapterExerciseId',
          joins: [
            {
              tableName: 'Chapter',
              on: 'chapterId',
            },
          ],
          columns: [
            {
              type: 'foreign',
              label: 'Chapitre',
              name: 'Chapter.name',
              idColumnName: 'chapterId',
              foreignIdColumnName: 'chapterId',
              searchField: 'name',
              tableName: 'Chapter',
            },
            {
              label: 'NomId',
              name: 'Chapter.nameId',
              hideInEdit: true,
            },
          ],
        },
        {
          type: 'table',
          label: 'Notions',
          tableName: 'ExerciseNotion',
          idColumnName: 'exerciseNotionId',
          route: 'exercise-notion',
          joins: [
            {
              tableName: 'Notion',
              on: 'notionId',
            },
          ],
          columns: [
            {
              type: 'foreign',
              label: 'Notion',
              name: 'Notion.nameFr',
              idColumnName: 'notionId',
              foreignIdColumnName: 'notionId',
              searchField: 'nameFr',
              tableName: 'Notion',
            },
          ],
        },
      ],
    },
    {
      label: 'Validation Admin',
      type: 'table',
      route: 'validation-exercice-admin',
      tableName: 'Exercise',
      idColumnName: 'exerciseId',
      icon: 'check-circle',
      orderBy: 'ExerciseSubmission.createdAt',
      orderByDirection: 'DESC',
      onEditApiRoute: '../../../back-office/exercise/:recordId',
      where:
        "Exercise.isPublic = false AND (ExerciseSubmission.status = 'submitted' OR ExerciseSubmission.status = 'toModify')",
      customFetchRoute: '../../../back-office/admin-exercise-submissions',
      canCreate: false,
      joins: [
        {
          tableName: 'ExerciseSubmission',
          type: 'LEFT',
          on: 'exerciseId',
        },
        {
          tableName: 'Administrator',
          type: 'LEFT',
          on: {
            leftId: 'ExerciseSubmission.submittedById',
            rightId: 'SubmittedBy.administratorId',
          },
          as: 'SubmittedBy',
        },
        {
          tableName: 'Administrator',
          type: 'LEFT',
          on: {
            leftId: 'ExerciseSubmission.assignedToId',
            rightId: 'AssignedTo.administratorId',
          },
          as: 'AssignedTo',
        },
      ],
      columns: [
        {
          label: 'Titre',
          name: 'name',
          searchable: true,
        },
        {
          label: 'Durée',
          name: 'duration',
          hideInTable: true,
        },
        {
          label: 'Difficulté',
          name: 'level',
          type: 'select',
          options: {
            elementary: 'Élémentaire',
            intermediate: 'Intermédiaire',
            advanced: 'Avancé',
          },
          hideInTable: true,
        },
        {
          label: 'Statut',
          name: 'ExerciseSubmission.status',
          type: 'select',
          options: {
            submitted: 'Soumis',
            refused: 'Refusé',
            toModify: 'À modifier',
            validated: 'Validé',
          },
          hideInEdit: true,
          searchable: true,
        },
        {
          label: 'Soumis par',
          name: 'SubmittedBy.firstName',
          format: {
            type: 'concatenate',
            config: {
              fields: ['SubmittedBy.lastName', 'SubmittedBy.firstName'],
              separator: ' ',
            },
          },
          hideInEdit: true,
        },
        {
          label: 'Assigné à',
          name: 'AssignedTo.firstName',
          format: {
            type: 'concatenate',
            config: {
              fields: ['AssignedTo.lastName', 'AssignedTo.firstName'],
              separator: ' ',
            },
          },
          hideInForm: true,
          hideInEdit: true,
        },
        {
          label: 'Assigné à',
          name: 'assignedTo',
          type: 'select',
          options: {
            'delphine.david@pyxiscience.com': 'Delphine',
            'pierrick@pyxiscience.com': 'Pierrick',
            'joachim.lebovits@pyxiscience.com': 'Joachim',
            'chabane@pyxiscience.com': 'Chabane',
            'sk168@nyu.edu': 'Selin',
            'nathalie@pyxiscience.com': 'Nathalie',
            'imene@pyxiscience.com': 'Imène',
            'raphael.h@pyxiscience.com': 'Raphael',
            'mohamed.triba@gmail.com': 'Mohammed',
            'ronan@pyxiscience.com': 'Ronan',
            'jacques@pyxiscience.com': 'Jacques',
            'paul@pyxiscience.com': 'Paul',
          },
          hideInDetails: true,
          hideInTable: true,
        },
        {
          label: 'Chapitres',
          name: 'chapters',
          hideInForm: true,
          hideInEdit: true,
          hideInDetails: true,
        },
        {
          label: 'Modules',
          name: 'modules',
          hideInForm: true,
          hideInEdit: true,
          hideInDetails: true,
        },
        {
          label: 'Commentaire',
          name: 'comment',
          type: 'textarea',
          hideInTable: true,
        },
        {
          label: 'Enoncé',
          name: 'statement',
          type: {
            default: 'myst',
            edit: 'myst-editor',
            view: 'string',
          },
          hideInTable: true,
          hideInEdit: true,
        },
        {
          label: 'Raison du refus',
          name: 'ExerciseSubmission.comment',
          hideInTable: true,
          hideInEdit: true,
        },
        {
          label: 'Action',
          type: 'actionValidateAdmin',
          hideInTable: true,
        },
        {
          label: 'Date de soumission',
          name: 'ExerciseSubmission.createdAt',
          type: 'datetime',
          hideInEdit: true,
        },
        {
          label: 'ID',
          name: 'exerciseId',
          hideInTable: true,
          searchable: true,
        },
      ],
      sidePanels: [
        {
          type: 'table',
          label: 'Modules',
          tableName: 'ModuleExercise',
          route: 'exercise-module',
          idColumnName: 'moduleExerciseId',
          joins: [
            {
              tableName: 'Module',
              on: 'moduleId',
            },
          ],
          columns: [
            {
              type: 'foreign',
              label: 'Module',
              name: 'Module.name',
              idColumnName: 'moduleId',
              foreignIdColumnName: 'moduleId',
              searchField: 'name',
              tableName: 'Module',
            },
            {
              label: 'NomId',
              name: 'Module.nameId',
              hideInEdit: true,
            },
          ],
        },
        {
          type: 'table',
          label: 'Chapitres',
          tableName: 'ChapterExercise',
          route: 'exercise-chapter',
          idColumnName: 'chapterExerciseId',
          joins: [
            {
              tableName: 'Chapter',
              on: 'chapterId',
            },
          ],
          columns: [
            {
              type: 'foreign',
              label: 'Chapitre',
              name: 'Chapter.name',
              idColumnName: 'chapterId',
              foreignIdColumnName: 'chapterId',
              searchField: 'name',
              tableName: 'Chapter',
            },
            {
              label: 'NomId',
              name: 'Chapter.nameId',
              hideInEdit: true,
            },
          ],
        },
        {
          type: 'table',
          label: 'Notions',
          tableName: 'ExerciseNotion',
          idColumnName: 'exerciseNotionId',
          route: 'exercise-notion',
          joins: [
            {
              tableName: 'Notion',
              on: 'notionId',
            },
          ],
          columns: [
            {
              type: 'foreign',
              label: 'Notion',
              name: 'Notion.nameFr',
              idColumnName: 'notionId',
              foreignIdColumnName: 'notionId',
              searchField: 'nameFr',
              tableName: 'Notion',
            },
          ],
        },
      ],
    },
    {
      label: 'Soumissions',
      type: 'table',
      route: 'submissions',
      tableName: 'Exercise',
      idColumnName: 'exerciseId',
      icon: 'check-circle',
      orderBy: 'ExerciseSubmission.createdAt',
      orderByDirection: 'DESC',
      where: `ExerciseSubmission.submittedById IS NOT NULL`,
      canCreate: false,
      joins: [
        {
          tableName: 'ExerciseSubmission',
          type: 'LEFT',
          on: 'exerciseId',
        },
        {
          tableName: 'Administrator',
          type: 'LEFT',
          on: {
            leftId: 'ExerciseSubmission.submittedById',
            rightId: 'SubmittedBy.administratorId',
          },
          as: 'SubmittedBy',
        },
        {
          tableName: 'Administrator',
          type: 'LEFT',
          on: {
            leftId: 'ExerciseSubmission.processedById',
            rightId: 'ProcessedBy.administratorId',
          },
          as: 'ProcessedBy',
        },
      ],
      columns: [
        {
          label: 'ID exercice',
          name: 'exerciseId',
          hideInTable: true,
          hideInEdit: true,
          searchable: true,
        },
        {
          label: 'Titre',
          name: 'name',
          searchable: true,
        },
        {
          label: 'Durée',
          name: 'duration',
          hideInTable: true,
        },
        {
          label: 'Difficulté',
          name: 'level',
          type: 'select',
          options: {
            elementary: 'Élémentaire',
            intermediate: 'Intermédiaire',
            advanced: 'Avancé',
          },
          hideInTable: true,
        },
        {
          label: 'Soumis par',
          name: 'SubmittedBy.firstName',
          format: {
            type: 'concatenate',
            config: {
              fields: ['SubmittedBy.lastName', 'SubmittedBy.firstName'],
              separator: ' ',
            },
          },
          hideInEdit: true,
        },
        {
          label: 'Traité par',
          name: 'ProcessedBy.firstName',
          format: {
            type: 'concatenate',
            config: {
              fields: ['ProcessedBy.lastName', 'ProcessedBy.firstName'],
              separator: ' ',
            },
          },
          hideInEdit: true,
        },
        {
          label: 'Enoncé',
          name: 'statement',
          type: {
            default: 'myst',
            edit: 'myst-editor',
            view: 'string',
          },
          hideInTable: true,
          hideInEdit: true,
        },
        {
          label: 'Statut',
          name: 'ExerciseSubmission.status',
          type: 'select',
          options: {
            submitted: 'Soumis',
            refused: 'Refusé',
            toModify: 'À modifier',
            validated: 'Validé',
          },
          hideInEdit: true,
          searchable: true,
        },
        {
          label: 'Commentaire',
          name: 'comment',
          hideInTable: true,
        },
        {
          label: 'Traité par',
          name: 'ProcessedBy.firstName',
          format: {
            type: 'concatenate',
            config: {
              fields: ['ProcessedBy.lastName', 'ProcessedBy.firstName'],
              separator: ' ',
            },
          },
          hideInTable: true,
          hideInEdit: true,
          searchable: true,
        },
        {
          label: 'Raison du refus',
          name: 'ExerciseSubmission.comment',
          hideInTable: true,
          hideInEdit: true,
        },
        {
          label: 'Action',
          type: 'actionValidateAdmin',
          hideInTable: true,
        },
        {
          label: 'Date de soumission',
          name: 'ExerciseSubmission.createdAt',
          type: 'datetime',
          hideInEdit: true,
        },
        {
          label: 'Date de traitement',
          name: 'ExerciseSubmission.processedAt',
          type: 'datetime',
          hideInEdit: true,
        },
      ],
      sidePanels: [
        {
          type: 'table',
          label: 'Modules',
          tableName: 'ModuleExercise',
          route: 'exercise-module',
          idColumnName: 'moduleExerciseId',
          joins: [
            {
              tableName: 'Module',
              on: 'moduleId',
            },
          ],
          columns: [
            {
              type: 'foreign',
              label: 'Module',
              name: 'Module.name',
              idColumnName: 'moduleId',
              foreignIdColumnName: 'moduleId',
              searchField: 'name',
              tableName: 'Module',
            },
            {
              label: 'NomId',
              name: 'Module.nameId',
              hideInEdit: true,
            },
          ],
        },
        {
          type: 'table',
          label: 'Chapitres',
          tableName: 'ChapterExercise',
          route: 'exercise-chapter',
          idColumnName: 'chapterExerciseId',
          joins: [
            {
              tableName: 'Chapter',
              on: 'chapterId',
            },
          ],
          columns: [
            {
              type: 'foreign',
              label: 'Chapitre',
              name: 'Chapter.name',
              idColumnName: 'chapterId',
              foreignIdColumnName: 'chapterId',
              searchField: 'name',
              tableName: 'Chapter',
            },
            {
              label: 'NomId',
              name: 'Chapter.nameId',
              hideInEdit: true,
            },
          ],
        },
        {
          type: 'table',
          label: 'Notions',
          tableName: 'ExerciseNotion',
          idColumnName: 'exerciseNotionId',
          route: 'exercise-notion',
          joins: [
            {
              tableName: 'Notion',
              on: 'notionId',
            },
          ],
          columns: [
            {
              type: 'foreign',
              label: 'Notion',
              name: 'Notion.nameFr',
              idColumnName: 'notionId',
              foreignIdColumnName: 'notionId',
              searchField: 'nameFr',
              tableName: 'Notion',
            },
          ],
        },
      ],
    },
    {
      label: 'Importation',
      type: 'custom',
      route: 'importation',
      path: 'ImportView.tsx',
    },
    {
      label: 'Éditeur',
      type: 'custom',
      route: 'editor',
      path: 'EditorView.tsx',
    },
    {
      label: 'Statistiques',
      type: 'custom',
      icon: 'bar-chart',
      route: 'metrics',
      path: 'MetricsView.tsx',
    },
  ],
  customComponents: [
    {
      type: 'myst',
      path: 'MystContent.tsx',
    },
    {
      type: 'myst-editor',
      path: 'MystEditor.tsx',
    },
    {
      type: 'actionExercise',
      path: 'ActionExercise.tsx',
    },
    {
      type: 'actionValidateTeacher',
      path: 'ActionValidateTeacher.tsx',
    },
    {
      type: 'actionValidateAdmin',
      path: 'ActionValidateAdmin.tsx',
    },
    {
      type: 'matomo-module-view',
      path: 'MatomoModuleView.tsx',
    },
    {
      type: 'actionUpdateExercise',
      path: 'ActionUpdateExercise.tsx',
    },
    {
      type: 'actionChapter',
      path: 'ActionChapter.tsx',
    },
    {
      type: 'actionDocumentation',
      path: 'ActionDocumentation.tsx',
    },
  ],
};
